const csvfiles = [
  "categories",
  "customers",
  "employee_territories",
  "employees",
  "order_details",
  "orders",
  "products",
  "regions",
  "shippers",
  "suppliers",
  "territories",
];

export default csvfiles;
